/**
 * Copyright (C) 2020, Merkur India.
 *
 * The program(s) herein may be used and/or copied only with
 * the written permission of Merkur India. or in accordance with
 * the terms and conditions stipulated in the agreement/contract
 * under which the program(s) have been supplied.
 *
 * $Id: GameConstants.ts ,v 1.0 Exp $
 * Date Author Changes
 * 3 July 2020 Sujata Nethani Created
 *
 */

namespace BS {
    /**
     * Class used for GameConstants lke SymbolsIDs etc.
     */
    export class GameConstants {
        public static readonly CHERRY: number = 0;
        public static readonly ORANGE: number = 1;
        public static readonly LEMON: number = 2;
        public static readonly PLUM: number = 3;
        public static readonly GRAPES: number = 4;
        public static readonly MELON: number = 5;
        public static readonly SUN: number = 6;
        public static readonly FPS: number = 15;
    }
}
